import i18n from '@/translation/i18n';

import isString from 'lodash.isstring';
import isEmpty from 'lodash.isempty';

const FilterItem = () => import('@/components/widgets/dataTable/FilterItem');

const createCheckboxListFilter = (
    name,
    options = [],
    textField = 'text',
    valueField = 'value',
    column = 'left',
    showInfoAlert = false
) => {
    if (isString(name)) {
        return {
            name,
            componentReference: FilterItem,
            aggregated_filter_values: options,
            description: i18n.t(`filters.labels.${name}`),
            loader: false,
            multiple: true,
            visibility: true,
            textField,
            valueField,
            column,
            showInfoAlert,
            infoAlertTitle: i18n.t(`filters.info.${name}`) ?? ''
        };
    }
    return {};
};

export const pendingFamiliesListFilters = (resources = {}) =>
    [
        {
            ...createCheckboxListFilter('provinces', resources?.provinces, 'display_value', 'provinceId')
        },
        { ...createCheckboxListFilter('locations', [], 'display_value', 'id', 'left', true) },
        { ...createCheckboxListFilter('volunteers', [], 'description', 'value', 'left', true) },
        {
            ...createCheckboxListFilter(
                'support_criteria',
                resources?.supportCriteria,
                'name',
                'support_criterion_id',
                'right'
            )
        },
        {
            ...createCheckboxListFilter(
                'status',
                resources?.status,
                'description',
                'family_edition_status_id',
                'right'
            )
        }
    ].filter((filterObject) => !isEmpty(filterObject));

export const qualifiedFamiliesListFilters = (resources = {}) =>
    [
        {
            ...createCheckboxListFilter('provinces', resources?.provinces, 'display_value', 'provinceId')
        },
        { ...createCheckboxListFilter('locations', [], 'display_value', 'id', 'left', true) },
        { ...createCheckboxListFilter('volunteers', [], 'description', 'value', 'left', true) },
        {
            ...createCheckboxListFilter(
                'help_criteria',
                resources?.helpCriteria,
                'name',
                'support_criterion_id',
                'right'
            )
        },
        {
            ...createCheckboxListFilter(
                'status',
                resources?.status,
                'description',
                'family_edition_status_id',
                'right'
            )
        },
        {
            ...createCheckboxListFilter(
                'advanced_status',
                [],
                'description',
                'family_edition_status_id',
                'right',
                true
            )
        }
    ].filter((filterObject) => !isEmpty(filterObject));

export default {
    pendingFamiliesListFilters,
    qualifiedFamiliesListFilters
};
